import React from "react";

import Page from "EmployeeApplication/Page";
import { useReopenCompanyPolicyMutation } from "EmployerApplication/api";
import { useSelector } from "react-redux";
import { companyTokenString } from "Utils/companyToken";
import { getSimpleDate } from "Utils/dateHelpers";
import { EmployerRenewalCompanyPolicy } from "Utils/types";

import { getCompanyPolicy } from "../Selectors";
import Button, { LinkButton } from "Cobalt/Button";
import { CardHeader, CardSection } from "Common/Card";

const SubmittedPage = () => {
  const companyPolicy = useSelector(getCompanyPolicy) as EmployerRenewalCompanyPolicy | undefined;
  const [reopenCompanyPolicy] = useReopenCompanyPolicyMutation();

  const handleReopen = async () => {
    if (companyPolicy?.id) {
      await reopenCompanyPolicy(companyPolicy.id).unwrap();
    }
  };

  const coverageStartDateAt = companyPolicy?.coverageStartDateAt;

  return (
    <Page title="Renewal Application Submitted">
      <CardHeader>Renewal Application Submitted!</CardHeader>
      <CardSection>
        <p>
          We have submitted your renewal application to the insurance carrier.
          {coverageStartDateAt && ` Your renewal policy will begin on ${getSimpleDate(new Date(coverageStartDateAt))}.`} We will email you when we receive
          confirmation from the insurance carrier that your renewal is finalized.
        </p>
        <p>
          If you need to make changes to your renewal you can return to the renewal application below. Please note that any changes you make will need to be
          resubmitted to the carrier. Once your renewal is finalized, employees can still make changes to their plans.
        </p>
        <Button color="secondary" onClick={handleReopen}>
          Return To Application
        </Button>
        <LinkButton href={`${companyTokenString()}/employer-dashboard`} color="primary" className="float-right">
          Back To Dashboard
        </LinkButton>
      </CardSection>
    </Page>
  );
};

export default SubmittedPage;
